// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { get } from 'lodash';
import moment from 'moment';

import request from '@helpers/request';
import api from '@constants/endpoints';
import IGame from '@interfaces/IGame';
import { PromotionFormValue } from './GamePromotionEditModal.types';
import { IPromotionGames, IPromotionGamesAction } from '@interfaces/IPromotionGames';

// получение списка игр
export async function fetchGameList(gameName: string): Promise<IGame[]> {
  return request(api.games.getList, { params: { filter: gameName } }).then((body) => {
    return get(body, ['data', 'body', 'content'], []).map((game: IGame) => ({
      label: game.name,
      value: game.id,
      image: game.image,
    }));
  });
}

// конвертирование объекта из Form ANTd в объект для запроса
export const mapValueToRequest = (values: PromotionFormValue): IPromotionGamesAction => {
  const { name, date, locale, id, position, gameId, searchSource } = values;
  let data: IPromotionGamesAction = {
    name,
    starts: date?.[0]?.format(),
    ends: date?.[1]?.format(),
    position,
    gameId: gameId,
    searchSource,
  };
  if (locale) {
    data = {
      ...data,
      accountFilter: {
        locales: locale === 'all' ? [] : [locale],
      },
    };
  }

  if (id) {
    data = { ...data, id };
  }

  return data;
};

export const mapValueToRequestOnCreate = (values: PromotionFormValue): IPromotionGamesAction => {
  const { name, date, locale, id, position, gameId, searchSource } = values;
  let data: IPromotionGamesAction = {
    name,
    starts: date?.[0]?.format(),
    ends: date?.[1]?.format(),
    position,
    gameId: gameId[0].value,
    searchSource,
  };
  if (locale) {
    data = {
      ...data,
      accountFilter: {
        locales: locale === 'all' ? [] : [locale],
      },
    };
  }

  if (id) {
    data = { ...data, id };
  }

  return data;
};

// конвертирование из объекта промо в объект для использования в Form ANTd
export const mapDataToFieldsValue = (values: IPromotionGames): PromotionFormValue => {
  const { id, name, starts, ends, position, filter, game, searchSource } = values;

  return {
    id,
    name,
    date: [moment(starts), moment(ends)],
    locale: filter?.locales?.[0] as PromotionFormValue['locale'],
    position,
    gameId: game?.id,
    searchSource,
  };
};

// правила валидации формы
export const rulesValidateForm = {
  name: {
    base: {
      required: true,
      whitespace: true,
    },
  },
  date: {
    base: {
      required: true,
    },
  },
  gameId: {
    base: {
      required: true,
    },
  },
  position: {
    base: {
      required: true,
    },
  },
  searchSource: {
    base: {
      required: true,
    },
  },
};
